export namespace Environment {
  export const backEndUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";
}
